import { Pipe, PipeTransform } from '@angular/core';

/**
 * DeviceLabelPipe
 *
 * Cleans up raw browser MediaDeviceInfo labels for display.
 *
 * Browser gives us labels like:
 *   "MacBook Pro Microphone (Built-in)"          → "MacBook Pro Microphone"
 *   "Default - MacBook Pro Microphone (Built-in)" → "MacBook Pro Microphone"
 *   "MacBook Pro Camera (0000:0001)"              → "MacBook Pro Camera"
 *
 * Usage in template:
 *   {{ mic.label | deviceLabel }}
 */
@Pipe({ name: 'deviceLabel', standalone: false })
export class DeviceLabelPipe implements PipeTransform {
  transform(label: string): string {
    if (!label) return 'Unknown device';
    return label
      .replace(/\s*\([0-9a-f]{4}:[0-9a-f]{4}\)/gi, '') // hardware IDs like (0000:0001)
      .replace(/\s*\(Built-?in\)/gi, '')                 // "(Built-in)" suffix
      .replace(/^Default\s*[-–]\s*/i, '')                // "Default - " prefix
      .trim();
  }
}
